module.exports = __webpack_public_path__ + "img/console.be814705.jpg";